<div class="dialog">
    <div class="dialog-header">
        <h3>{{ 'SALES_DOCUMENT|Anulowanie zamówienia' | translate }}</h3>
        <button
                iccIconButton
                (click)="close()"
                appearance="flat"
            >
            <icc-icon name="close"></icc-icon>
        </button>
    </div>
    <div class="dialog-body">
        <p>{{ data.body }}</p>
    </div>
    <div class="dialog-footer flex-vertical">

        <div class="flex-horizontal w-100">

            <button
                iccButton
                (click)="close()"
                appearance="secondary"
                [disabled]="inProgress"
            >
                {{ 'INTERFACE|Nie' | translate}}
            </button>

            <div class="right">
                <span class="space"></span>
                <button iccButton (click)="cancel()" [disabled]="inProgress">{{ 'INTERFACE|Tak' | translate}}</button>
            </div>

        </div>
        <div class="w-100" *ngIf="!messages.length && message">
            <p [class.error]="messageState === 'error'" class="dialog-message">{{ message }}</p>
        </div>
        <div class="w-100" *ngIf="messages.length">
            <p [class.error]="messageState === 'error'" class="dialog-message" *ngFor="let msg of messages">{{ msg }}</p>
        </div>
    </div>
</div>
<div
    class="curtain"
    (click)="close()"
></div>
